import { useEffect, useRef, useState } from "react";

export function calculateTaskEffort(
  workingHours: number,
  duration: number,
  workingHoursPerDay: number
): number {
  const totalAvailable = duration * workingHoursPerDay;
  if (totalAvailable === 0) return 0;
  return Math.round((workingHours / totalAvailable) * 100);
}

export function calculateTotalHours(
  effort: number,
  duration: number,
  workingHoursPerDay: number
): number {
  const totalAvailable = duration * workingHoursPerDay;
  return (effort / 100) * totalAvailable;
}

export function useEffortCalculation(
  initialEffort: number,
  duration: number,
  initialHours: number
) {
  const [totalHours, setTotalHours] = useState<number>(initialHours);
  const [taskEffort, setTaskEffort] = useState<number>(initialEffort);

  const previousDuration = useRef(duration);

  // If duration changes, don't recalculate hours, only effort
  useEffect(() => {
    if (previousDuration.current !== duration) {
      const updatedEffort = calculateTaskEffort(
        totalHours,
        duration,
        8
      );
      setTaskEffort(updatedEffort);
      previousDuration.current = duration;
    }
  }, [duration, totalHours]);
  
  return {
    taskEffort,
    totalHours,
    duration,
    setTaskEffort,
    setTotalHours,
  };
}
